// src/utils/questions.js

export const questions = [
    {
      id: "fullName",
      label: "Cuál es su nombre y apellido?",
      type: "fullName",
      required: true,
    },
    {
      id: "sexo",
      label: "Sexo:",
      type: "radio",
      options: [
        { value: "masculino", label: "Masculino" },
        { value: "femenino", label: "Femenino" },
      ],
      required: true,
    },
    {
      id: "fechaNacimiento",
      label: "Fecha de nacimiento:",
      type: "date",
      required: true,
    },
    {
      id: "edad",
      label: "Edad:",
      type: "text",
      readOnly: true,
      required: false,
      placeholder: "Se calcula automáticamente",
    },
    {
      id: "licenciaCliente",
      label: "Número de licencia del cliente:",
      type: "text",
      required: true,
      placeholder: "XXXXXXX",
    },
    {
      id: "respLicencia",
      label: "Licencia del responsable (si menor de edad):",
      type: "text",
      required: false,
    },
    {
      id: "respParentesco",
      label: "Parentesco del responsable (si menor de edad):",
      type: "text",
      required: false,
    },
    { id: "direccion", label: "Dirección:", type: "text", required: true },
    {
      id: "email",
      label: "Correo electrónico:",
      type: "text",
      inputType: "email",
      required: true,
    },
    {
      id: "confirmEmail",
      label: "Confirme su correo electrónico:",
      type: "text",
      inputType: "email",
      required: true,
    },
    {
      id: "telefono",
      label: "Teléfono:",
      type: "text",
      inputType: "tel",
      required: true,
    },
    {
      id: "emergencia",
      label: "Contacto de Emergencia",
      type: "multi-input",
      inputs: [
        {
          id: "emergNombre",
          label: "Nombre:",
          type: "text",
          required: true,
        },
        {
          id: "emergParentesco",
          label: "Parentesco:",
          type: "text",
          required: true,
        },
        {
          id: "emergTelefono",
          label: "Tel:",
          type: "text",
          required: true,
        },
      ],
    },
    {
      id: "cond_embarazo",
      label: "Embarazada Actualmente",
      type: "radio",
      options: [
        { value: "si", label: "Sí" },
        { value: "no", label: "No" },
      ],
      required: true,
    },
    {
      id: "cond_lactando",
      label: "Lactando",
      type: "radio",
      options: [
        { value: "si", label: "Sí" },
        { value: "no", label: "No" },
      ],
      required: true,
    },
    {
      id: "cond_alergias_piel",
      label: "Alergias en la piel",
      type: "radio",
      options: [
        { value: "si", label: "Sí" },
        { value: "no", label: "No" },
      ],
      required: true,
    },
    {
      id: "cond_diabetes",
      label: "Diabetes",
      type: "radio",
      options: [
        { value: "si", label: "Sí" },
        { value: "no", label: "No" },
      ],
      required: true,
    },
    {
      id: "cond_alta_presion",
      label: "Alta Presión",
      type: "radio",
      options: [
        { value: "si", label: "Sí" },
        { value: "no", label: "No" },
      ],
      required: true,
    },
    {
      id: "cond_cardiovascular",
      label: "Cardiovascular",
      type: "radio",
      options: [
        { value: "si", label: "Sí" },
        { value: "no", label: "No" },
      ],
      required: true,
    },
    {
      id: "cond_autoinmune",
      label: "Enfermedad Autoinmune",
      type: "radio",
      options: [
        { value: "si", label: "Sí" },
        { value: "no", label: "No" },
      ],
      required: true,
    },
    {
      id: "cond_renal",
      label: "Problema Renal",
      type: "radio",
      options: [
        { value: "si", label: "Sí" },
        { value: "no", label: "No" },
      ],
      required: true,
    },
    {
      id: "cond_cancer_piel",
      label: "Cáncer en la piel",
      type: "radio",
      options: [
        { value: "si", label: "Sí" },
        { value: "no", label: "No" },
      ],
      required: true,
    },
    {
      id: "cond_rosacea",
      label: "Rosácea",
      type: "radio",
      options: [
        { value: "si", label: "Sí" },
        { value: "no", label: "No" },
      ],
      required: true,
    },
    {
      id: "cond_epilepsia",
      label: "Epilepsia o convulsiones",
      type: "radio",
      options: [
        { value: "si", label: "Sí" },
        { value: "no", label: "No" },
      ],
      required: true,
    },
    {
      id: "cond_asma",
      label: "Asma",
      type: "radio",
      options: [
        { value: "si", label: "Sí" },
        { value: "no", label: "No" },
      ],
      required: true,
    },
    {
      id: "alergiasComidasMeds",
      label: "Alérgic@ a comidas y/o medicamentos:",
      type: "text",
      required: false,
      placeholder: "Solo si aplica (campo no requerido)",
    },
    {
      id: "tratamientosCirugias",
      label: "Tratamientos o cirugías recientes:",
      type: "text",
      required: false,
      placeholder: "Solo si aplica (campo no requerido)",
    },
    {
      id: "medicamentos",
      label: "Medicamento que estés utilizando:",
      type: "text",
      required: false,
      placeholder: "Solo si aplica (campo no requerido)",
    },
    {
      id: "tratamientosArea",
      label: "¿Ha recibido/recibe tratamientos para el área a tratar?",
      type: "radio",
      options: [
        { value: "si", label: "Sí" },
        { value: "no", label: "No" },
      ],
      required: true,
    },
    {
      id: "detalleTratamientosArea",
      label: "En caso afirmativo, cuéntenos:",
      type: "text",
      required: false,
      placeholder: "Solo si aplica (campo no requerido)",
    },
    {
      id: "ultimoTratamiento",
      label: "¿Cuándo fue su último tratamiento?",
      type: "date", 
      required: false,
      placeholder: "Solo si aplica (campo no requerido)",
    },
    {
      id: "motivoConsulta",
      label: "Motivo de consulta:",
      type: "text",
      required: true,
    },
    {
      id: "servicio",
      label: "¿Qué servicio desea solicitar?",
      type: "radio",
      options: [
        { value: "depilacion_laser", label: "Depilación Láser" },
        { value: "facial", label: "Facial Rejuvenecedor" },
        { value: "masaje", label: "Masaje Relajante" },
      ],
      required: true,
    }
  ];

export const buildEmptyAnswers = () => {
  const answers = {};
  for (const question of questions) {
    if (question.type === "multi-input" && Array.isArray(question.inputs)) {
      for (const input of question.inputs) {
        answers[input.id] = "";
      }
    } else if (question.type === "checkbox-group") {
      answers[question.id] = [];
    } else {
      answers[question.id] = "";
    }
  }
  return answers;
};
  
